import React from 'react';
import { ClienteConsolidado } from '../types';
import { formatCurrency, formatPercent } from '../utils';

interface Props {
  clientes: ClienteConsolidado[];
  totalAberto: number;
}

const MapaGoias: React.FC<Props> = ({ clientes, totalAberto }) => {
  // Agrupar por cidade
  const cidadesMap = new Map<string, { valor: number, clientes: number }>();
  
  clientes.forEach(c => {
    c.cidades.forEach(cid => {
      if (!cidadesMap.has(cid)) cidadesMap.set(cid, { valor: 0, clientes: 0 });
      const current = cidadesMap.get(cid)!;
      current.valor += c.valorTotal / c.cidades.length; // split value if multiple cities
      current.clientes += 1;
    });
  });

  const rankingCidades = Array.from(cidadesMap.entries())
    .map(([cidade, stats]) => ({
      cidade,
      valor: stats.valor,
      qtd: stats.clientes,
      pct: totalAberto > 0 ? (stats.valor / totalAberto) * 100 : 0
    }))
    .sort((a, b) => b.valor - a.valor);

  const maxValor = rankingCidades[0]?.valor || 1;

  return (
    <div className="p-6 h-full flex flex-col">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-800">Mapa Executivo de Goiás</h2>
        <p className="text-sm text-gray-500">Distribuição geográfica da inadimplência (Heatmap Cidades)</p>
      </div>

      <div className="flex-1 bg-white border border-gray-200 rounded-xl overflow-hidden flex flex-col p-6">
        <div className="overflow-y-auto pr-4 space-y-4">
          {rankingCidades.map((c, i) => (
            <div key={i} className="flex items-center gap-4">
              <div className="w-48 flex-shrink-0">
                <p className="text-sm font-bold text-gray-800 truncate">{c.cidade}</p>
                <p className="text-[10px] text-gray-500">{c.qtd} clientes</p>
              </div>
              <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden">
                <div 
                  className="h-full rounded-full" 
                  style={{ 
                    width: `${(c.valor / maxValor) * 100}%`,
                    background: i === 0 ? '#ef4444' : i < 3 ? '#f97316' : '#5F6C37'
                  }} 
                />
              </div>
              <div className="w-32 text-right flex-shrink-0">
                <p className="text-sm font-black text-gray-700">{formatCurrency(c.valor)}</p>
                <p className="text-[10px] font-semibold text-gray-500">{formatPercent(c.pct)}</p>
              </div>
            </div>
          ))}
          {rankingCidades.length === 0 && (
            <p className="text-center text-gray-500 py-10">Nenhum dado geográfico disponível.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapaGoias;
